/* Gallery 024 — homepage JS: reveal-on-scroll + voor/na-vergelijking.
   Idempotent, werkt met muis, touch én toetsenbord. */
(function () {
  function initReveal(root) {
    var targets = (root || document).querySelectorAll('.g024 [data-anim]:not(.g024-io)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('g024-io', 'in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    targets.forEach(function (el) { el.classList.add('g024-io'); io.observe(el); });
  }

  function initBa(root) {
    (root || document).querySelectorAll('[data-g024-ba]:not(.g024-ba-init)').forEach(function (ba) {
      ba.classList.add('g024-ba-init');

      var handle = ba.querySelector('[data-g024-ba-handle]');
      var labelRight = (ba.querySelector('.tag.r') || {}).textContent || '';
      var pos = 50;

      function apply() {
        ba.style.setProperty('--x', pos + '%');
        if (handle) {
          handle.setAttribute('aria-valuenow', Math.round(pos));
          handle.setAttribute('aria-valuetext', Math.round(pos) + '% ' + labelRight.trim());
        }
      }

      function setFromClientX(clientX) {
        var r = ba.getBoundingClientRect();
        if (!r.width) return;
        pos = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
        apply();
      }

      var dragging = false;
      ba.addEventListener('pointerdown', function (e) {
        dragging = true;
        if (ba.setPointerCapture) { try { ba.setPointerCapture(e.pointerId); } catch (err) {} }
        setFromClientX(e.clientX);
        if (handle) handle.focus({ preventScroll: true });
      });
      ba.addEventListener('pointermove', function (e) { if (dragging) setFromClientX(e.clientX); });
      ba.addEventListener('pointerup', function () { dragging = false; });
      ba.addEventListener('pointercancel', function () { dragging = false; });
      ba.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var step = e.shiftKey ? 10 : 2;
          var next = pos;
          switch (e.key) {
            case 'ArrowLeft': case 'ArrowDown': next = pos - step; break;
            case 'ArrowRight': case 'ArrowUp': next = pos + step; break;
            case 'Home': next = 0; break;
            case 'End': next = 100; break;
            case 'PageDown': next = pos - 10; break;
            case 'PageUp': next = pos + 10; break;
            default: return;
          }
          e.preventDefault();
          pos = Math.max(0, Math.min(100, next));
          apply();
        });
        handle.addEventListener('click', function (e) { e.preventDefault(); });
      }

      apply();
    });
  }

  function init(root) { initReveal(root); initBa(root); }

  if (!window.__g024HomeInit) {
    window.__g024HomeInit = 1;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    // Theme-editor: opnieuw binden als een sectie herladen wordt.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  } else {
    init(document);
  }
})();
